import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default function NotificationsViewAll() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('https://physiodirectory.in/api/notifications')
      .then(res => setNotifications(res.data.notifications || []))
      .catch(() => setNotifications([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="container-fluid px-3 pb-5 pt-3">
      <div className="d-flex align-items-center mb-3">
        <Link to="/" className="btn btn-link p-0 me-2" style={{fontSize: '1.5rem'}}><i className="bi bi-arrow-left"></i></Link>
        <h2 className="section-title mb-0">All Notifications</h2>
      </div>
      {loading ? (
        <div className="text-center py-3">Loading...</div>
      ) : notifications.length === 0 ? (
        <h4 className="fw-semibold text-muted mb-2">No notifications found</h4>
      ) : (
        <div className="row g-3">
          {notifications.map(n => (
            <div className="col-12 col-md-6" key={n.id}>
              <div className="card h-100 shadow-sm border-0 notification-card-web">
                <div className="notification-image-wrapper" style={{height: '140px', overflow: 'hidden', borderTopLeftRadius: '12px', borderTopRightRadius: '12px'}}>
                  <img src={n.image ? n.image : '/assets/notification-default.png'} alt={n.title} style={{width: '100%', height: '100%', objectFit: 'cover', borderTopLeftRadius: '12px', borderTopRightRadius: '12px'}} onError={e => {e.target.onerror=null; e.target.src='/assets/notification-default.png';}} />
                </div>
                <div className="card-body p-3 d-flex flex-column">
                  <h6 className="fw-bold mb-1" style={{ fontSize: '1.1rem', color: '#2d3748' }}>{n.title}</h6>
                  <div className="text-muted small mb-1">{n.date}</div>
                  <div className="mb-2 text-truncate">{n.description}</div>
                  <button
                    className="btn btn-outline-primary w-100 rounded-pill fw-semibold mt-auto"
                    style={{fontSize: '0.95rem'}}
                    onClick={() => {
                      const url = `https://physiodirectory.in/notifications/${n.id}`;
                      if (window.ReactNativeWebView) {
                        window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'openExternal', url }));
                      } else {
                        window.open(url, '_blank');
                      }
                    }}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
